import PaneWrapper from './PaneWrapper';

export default PaneWrapper;